import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import Link from "@mui/material/Link";

// Helper
import { statusMessagesColorScheme } from "../../helpers/utils";
import { sanitizeHTML } from "../../helpers/sanitizeHtml";

const useStyles = makeStyles({
  statusMessagesCss: {
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "1rem 0",
    border: "1px inset black",
  },
  notificationTitle: {
    "& a": {
      color: "#000000",
      textDecoration: "underline",
    },
  },
});

const MDCGroupNotification = (props) => {
  const { statusMessagesCss, notificationTitle } = useStyles();
  const { title, nachrichtenTyp, description } = props.groupBannerData;
  return (
    <>
      {title?.length ? (
        <Grid
          container
          backgroundColor={statusMessagesColorScheme[nachrichtenTyp]?.color}
          color={statusMessagesColorScheme[nachrichtenTyp]?.textColor}
          className={statusMessagesCss}
        >
          {/**Left Icon*/}
          <Grid item xs={1.5}>
            {statusMessagesColorScheme[nachrichtenTyp]?.icon}
          </Grid>

          {/**Global Notification messages for Whole Group*/}
          <Grid item xs={6.5}>
            <Box component="span">
              <Box
                className={notificationTitle}
                component="span"
                sx={{ display: "inline" }}
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(title + " "),
                }}
              />

              {description?.length ? (
                <Link
                  component="button"
                  color="inherit"
                  variant="body1"
                  onClick={() => props.showMessageDetailDialog(description)}
                >
                  Details
                </Link>
              ) : (
                <></>
              )}
            </Box>
          </Grid>

          {/**Right Icon */}
          <Grid item xs={1.5}>
            {statusMessagesColorScheme[nachrichtenTyp]?.icon}
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default MDCGroupNotification;
